import Vue from "vue";

export default {
  get(url, request) {
    return Vue.axios
      .get(url, request)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error));
  },
  post(url, request) {
    return Vue.axios
      .post(url, request)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },
  patch(url, request) {
    return Vue.axios
      .patch(url, request)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },
  delete(url, request) {
    return Vue.axios
      .delete(url, request)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }
};
